import { useState } from 'react'

import { PhotoLightbox } from './DetailPhoto'

/** Thumbnail strip for an event's attachments. Fixed dimensions avoid layout shift; clicking a
 *  thumbnail opens the same in-place zoom lightbox as the main issue photo (not a new tab). */
export function IssueEventPhotos({ urls }: { urls: string[] }) {
  const [zoomUrl, setZoomUrl] = useState<string | null>(null)
  if (urls.length === 0) {
    return null
  }
  return (
    <div className="mt-1.5 flex flex-wrap gap-1.5">
      {urls.map((u, i) => (
        <button
          key={`${u}-${i}`}
          type="button"
          onClick={() => setZoomUrl(u)}
          aria-label={`Open attachment ${i + 1}`}
          className="block cursor-zoom-in rounded-md focus-visible:ring-2 focus-visible:ring-blue-500/60"
        >
          <img
            src={u}
            alt={`Attachment ${i + 1}`}
            width={56}
            height={56}
            loading="lazy"
            className="h-14 w-14 rounded-md border border-slate-900/10 object-cover"
          />
        </button>
      ))}
      {zoomUrl && <PhotoLightbox src={zoomUrl} alt="Timeline attachment" onClose={() => setZoomUrl(null)} />}
    </div>
  )
}
